
<template>
  <div>
    <v-subheader>Peso do item</v-subheader>
    <v-sheet class="ml-2" max-width="1000" >
      <v-row align="center" justify="start" class="mx-3">
        
        <v-slide-group mandatory v-model="newItem.weight" center-active class="mr-10 mb-2" v-if="newItem.weight <= 5">
          <v-slide-item :value="kind.kind" v-for="(kind,idx) in allWeights" :key="'ckind5'+idx" v-slot:default="{ active, toggle }">
            <v-btn fab small class="mr-1" depressed :input-value="active" @click="toggle" 
              active-class="secondary darken-1 white--text"
            >
              <v-icon >{{kind.icon}}</v-icon>
              <!-- {{kind.name}} -->
            </v-btn>
          </v-slide-item>
        </v-slide-group>


        <v-dialog v-model="dialog" max-width="500px" transition="dialog-transition" >
          <template v-slot:activator="{on}">
            <v-btn v-on="on" :class="['ml-1 mb-2',Number(newItem.weight)> 5? 'primary white--text' : '']" depressed rounded class="" >
              <v-icon left>mdi-weight</v-icon> {{Number(newItem.weight)> 5? `${newItem.weight}` : 'Customizado'}}
            </v-btn>
          </template>
          <v-card style="border-radius:12px" :outlined="$vuetify.theme.isDark">
            <v-card-title primary-title>
              <div class="headline mb-0">Peso customizado</div>
            </v-card-title>
            <v-card-text>
              <v-text-field v-model="newItem.weight" color="secondary" prepend-icon="mdi-weight" type="number" label="Peso do item"></v-text-field>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn text @click="dialog= false; newItem.weight = '1'" color="error">Limpar</v-btn>
              <v-btn text @click="dialog= false;" color="success">OK</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-row>
    </v-sheet>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  data() {
    return {
      dialog: false,
      newItem: this.$attrs.newItem,
      allWeights: [
        {name: '0', kind: '0', icon:'mdi-numeric-0-circle'},
        {name: '1', kind: '1', icon:'mdi-numeric-1-circle'},
        {name: '2', kind: '2', icon:'mdi-numeric-2-circle'},
        {name: '3', kind: '3', icon:'mdi-numeric-3-circle'},
        {name: '4', kind: '4', icon:'mdi-numeric-4-circle'},
        {name: '5', kind: '5', icon:'mdi-numeric-5-circle'},
      ],
    }
  },
  methods: {
    names() {
      
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  created () {
    this.newItem.weight = ['object', 'undefined'].includes(typeof(this.newItem.weight))? '1' : this.newItem.weight
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>